import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/base/Button';
import DatePicker from 'components/base/DatePicker';
import { SendToShopModalProps } from './types/types';

export const SendToShopModal: React.FC<SendToShopModalProps> = ({
  show,
  onHide,
  onConfirm
}) => {
  const [date, setDate] = useState<Date>(new Date());

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select Date & Time</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DatePicker
          options={{ enableTime: true, dateFormat: 'Y-m-d H:i' }}
          value={date}
          onChange={d => {
            const newDate = Array.isArray(d) ? d[0] : d;
            if (newDate instanceof Date) {
              setDate(newDate);
            }
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => onConfirm(date)}>
          Confirm & Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
